import React from 'react'
import PropTypes from 'prop-types'

import queryGraphql from '@shared/components/queryGraphql'
import { CURRENT_MATCHES } from '@graphql/fixtures/fixtures.query'
import { checkRedirectionStatus, currentMonthYear, getTimeZone, handleApiError } from '@shared-submodule/utils'
import Error from '@shared/components/error'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { CURRENT_SERIES_LIST } from '@graphql/globalwidget/rankings.query'
import dynamic from 'next/dynamic'
const FixtureContent = dynamic(() => import('@shared/components/fixtureContent'))
const ScheduleContent = dynamic(() => import('@shared/components/scheduleContent'))

function CricketSchedule({ data, seoData, currentSeriesData }) {
  return (
    <FixtureContent type='scheduleByMonth' seoData={seoData} currentSeriesData={currentSeriesData} >
      <ScheduleContent data={data} />
    </FixtureContent>
  )
}

CricketSchedule.propTypes = {
  data: PropTypes.object,
  seoData: PropTypes.object,
  currentSeriesData: PropTypes.object
}

export default Error(CricketSchedule)

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=5')

    const { allRoutes } = (await import('@shared-submodule/sm-constants/allRoutes'))
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: allRoutes.cricketSchedule?.slice(1) } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    const { data } = await queryGraphql(CURRENT_MATCHES, { input: { eCategory: 'i', dByMonth: currentMonthYear(), sTimezone: getTimeZone(), nLimit: 10, nSkip: 1 } })
    const { data: currentSeriesData } = await queryGraphql(CURRENT_SERIES_LIST)
    return {
      props: {
        data,
        seoData: seoData?.getSeoData,
        currentSeriesData: currentSeriesData
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
